import { render } from "./edit-lead.vue?vue&type=template&id=64ebcaa2"
import script from "./edit-lead.vue?vue&type=script&lang=js"
export * from "./edit-lead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__